import Swal from "sweetalert2";

export const swalModal = (type) => {
  const { success } = type;
  return Swal.fire({
    title: success ? "Exito!" : "Error!",
    html: success
      ? "Formulario enviado correctamente"
      : "Error al enviar el formulario. <br> Recarga e Inténtalo de nuevo.",
    icon: success ? "success" : "error",
    width: "420px",
    customClass: {
      title: "custom-swal-title",
      icon: "custom-swal-icon",
      popup: "custom-swal-popup",
      htmlContainer: "custom-swal-html",
      actions: "custom-swal-actions",
      confirmButton: "custom-swal-btn",
    },
    confirmButtonText: "OK",
  });
};